import { computed, DestroyRef, inject, Injectable } from '@angular/core';
import { AuthApiService } from '@infrastructure/api/auth';
import { AuthStore } from '../data';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { IAuthDto } from '@domain/auth';
import { catchError, Observable, tap, throwError } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class AuthFacade {
  readonly #api = inject(AuthApiService);
  readonly #store = inject(AuthStore);
  readonly #destroyRef = inject(DestroyRef);

  readonly vm = computed(() => {
    return {
      loading: this.#store.loading(),
      user: this.#store.user(),
      error: this.#store.error(),
    };
  });

  public login(dto: IAuthDto): void {
    this.#store.setLoading(true);
    this.#api
      .authenticate(dto)
      .pipe(takeUntilDestroyed(this.#destroyRef))
      .subscribe({
        next: response => {
          this.#store.setUser(response);
          this.#store.setLoading(false);
          this.#store.setError(null);
        },
        error: error => {
          console.error('Authentication failed:', error);
          this.#store.setLoading(false);
          this.#store.setError(error);
        },
      });
  }

  public login$(dto: IAuthDto): Observable<any> {
    this.#store.setLoading(true);
    return this.#api.authenticate(dto).pipe(
      tap(user => {
        this.#store.setUser(user);
        this.#store.setLoading(false);
        this.#store.setError(null);
      }),
      catchError(error => {
        this.#store.setLoading(false);
        this.#store.setError(error);
        return throwError(() => error);
      })
    );
  }
}
